import { useEffect, useState } from "react"

import { Switch, Label } from "twyne-new.ui"

const useActiveForm = item => {
  const [active, setActive] = useState()
  useEffect(() => {
    setTimeout(() => {
      if (active === undefined) {
        setActive(item?.id ? item?.active : true)
      }
    }, 300)
  }, [item, active])

  return { active: active === undefined ? true : active, setActive }
}

const ActiveForm = ({ active, onChangeActive }) => <>
  <div className='flex gap-2 items-center'>
    <Switch name="active" size='lg' title="Active" value={active} onChange={e => onChangeActive(e.target.checked)} />
    <Label>Active</Label>
  </div>
</>

export { useActiveForm, ActiveForm }
